export const findOneFieldByKind = (kind: string, itemDisplayProperty: any[]) =>
    itemDisplayProperty.find((it) => it.kind === kind);
